import { atomWithStorage } from "jotai/utils";

/** The visitor's saved practitioners, by username — the only state this feature keeps. No account, no
 *  sync: it's `localStorage` under a jotai atom so every card and the `/saved` page share one copy. */
export const savedPractitionerIdsAtom = atomWithStorage<string[]>("cmw:saved-practitioners", []);
